<div class="modal-container">
  <div class="modal-header">
    <h2> {{ config.title }} </h2>
    <button class="close-button" aria-label="Close" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

 <div class="modal-body">
    <app-inline-message [type]="bannerType() || ''" 
      [title]="config.banner?.title || ''" 
      [description]="config.banner?.description || ''"
      [note]="config.banner?.note || ''">

    </app-inline-message>
    <p class="modal-body-text" *ngIf="config.message">{{ config.message }}</p>
  </div>

  <div class="modal-body cancel-reason-section" *ngIf="config.from === 'cancel'">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ config.reasonCodes?.length ? 'Select reason for cancellation *' : 'Select reason for cancellation' }}</mat-label>
      <mat-select [(ngModel)]="selectedReason" [disabled]="isReasonSelectDisabled">
        <mat-option *ngFor="let reason of config.reasonCodes" [value]="reason">
          {{ reason.mfgReasonDesc }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <section class="buttons">
    <button class="yes-button"
      [disabled]="isConfirmDisabled"
      (click)="onConfirm()">
      {{ config.confirmText || 'Yes, discard' }} 
    </button>
    <button class="no-button" (click)="onCancel()">
      {{ config.cancelText || 'No, stay on this page'}} 
    </button>
  </section>
</div>